import React, { useState, useEffect } from "react";
import { sort } from "fast-sort";
import { format } from "date-fns";
import IconLoader from "components/IconLoader/IconLoader";
import EmptyTableAnimation from "components/Animations/EmptyTableAnimation";

export default function RegisteredExamsList({
  applicationList,
  setSelectedApplication,
  changeMultiplePageMode
}) {
  const [activeApplicationList, setActiveApplicationList] = useState([]);
  const [passiveApplicationList, setPassiveApplicationList] = useState([]);

  useEffect(() => {
    if (applicationList?.length > 0) {
      const currentDate = new Date();
      setActiveApplicationList(
        sort(applicationList)
          .desc((item) => new Date(item?.examDate).getTime())
          ?.filter((application) =>
            application?.examDate
              ? new Date(application.examDate).getTime() >= currentDate.getTime()
              : false
          ) || []
      );
      setPassiveApplicationList(
        sort(applicationList)
          .desc((item) => new Date(item?.examDate).getTime())
          ?.filter((application) =>
            application?.examDate
              ? new Date(application.examDate).getTime() < currentDate.getTime()
              : false
          ) || []
      );
    }
  }, [JSON.stringify(applicationList)]);

  const openApplicationInfoPage = (application) => {
    setSelectedApplication(application);
    const modeList = [
      { name: "registerForm", open: false },
      { name: "identityCheck", open: false },
      { name: "validEntry", open: true },
      { name: "applicationList", open: false },
      { name: "examResults", open: false },
      { name: "registerMenu", open: false }
    ];
    changeMultiplePageMode(modeList)();
  };

  const handleApplicationList = () => {
    const modeList = [
      { name: "registerForm", open: false },
      { name: "identityCheck", open: false },
      { name: "validEntry", open: false },
      { name: "applicationList", open: false },
      { name: "examResults", open: false },
      { name: "registerMenu", open: true }
    ];
    changeMultiplePageMode(modeList)();
  };

  return (
    <>
      <div className="container pt-6" style={{ position: "relative" }}>
        <button
          onClick={handleApplicationList}
          className="btn btn-primary d-none d-lg-block"
          style={{ position: "absolute", left: -85 }}
        >
          <IconLoader icon="mdiChevronLeft" size={1} />
        </button>
        <div className="d-flex w-100 justify-content-center">
          <img src="/media/register/registerTitleImage.png" style={{ maxWidth: "100%" }} />
        </div>

        {activeApplicationList?.length > 0 && (
          <>
            <div className="d-flex w-100 justify-content-center mt-8 mb-4">
              <span className="h3 text-primary">Aktif Sınav Başvuruları</span>
            </div>
            <div className="w-100 row px-xl-40 px-lg-20 px-md-10">
              {activeApplicationList?.map((application, index) => (
                <div key={index} className="col-md-12 col-12 p-4">
                  <button
                    className="btn btn-outline-info d-flex flex-column justify-content-center align-items-center w-100"
                    onClick={() => openApplicationInfoPage(application)}
                  >
                    <span className="font-weight-bolder ">{application.examSchoolName}</span>
                    <span className="mt-2">
                      {format(new Date(application.examDate), "dd/MM/yyyy HH:mm")}
                    </span>
                    <span className="mt-2">{application.examName}</span>
                    <span className="mt-2">{application.examLevel}</span>
                  </button>
                </div>
              ))}
            </div>
          </>
        )}

        {passiveApplicationList?.length > 0 && (
          <>
            <div className="d-flex w-100 justify-content-center mt-8 mb-4">
              <span className="h3 text-primary">Geçmiş Sınav Başvuruları</span>
            </div>
            <div className="w-100 row px-xl-40 px-lg-20 px-md-10">
              {passiveApplicationList?.map((application, index) => (
                <div key={index} className="col-md-12 col-12 p-4">
                  <button
                    className="btn btn-outline-info d-flex flex-column justify-content-center align-items-center w-100"
                    onClick={() => openApplicationInfoPage(application)}
                  >
                    <span className="font-weight-bolder ">{application.examSchoolName}</span>
                    <span className="mt-2">
                      {format(new Date(application.examDate), "dd/MM/yyyy HH:mm")}
                    </span>
                    <span className="mt-2">{application.examName}</span>
                    <span className="mt-2">{application.examLevel}</span>
                  </button>
                </div>
              ))}
            </div>
          </>
        )}

        {activeApplicationList?.length === 0 && passiveApplicationList?.length === 0 && (
          <div className="d-flex flex-column align-items-center p-xl-16 p-lg-14 p-md-10 p-6">
            <div className="d-flex flex-column align-items-center w-100">
              <span className="font-weight-bold mt-4 h6">Başvuru Yapılan Sınav Bulunamadı...</span>
              <EmptyTableAnimation />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
